import * as React from "react";
import { FormControl, Link } from "@mui/material";
import {
  DescriptionContainer,
  Form,
  FormContainer,
  FormErrorText,
  FormInputLabel,
  FormText,
  FormTitle,
  FromInput,
  PrivacyText,
  SubmitButton,
} from "./styled";

export default function LoginFom({
  login,
}: {
  login: (username: string, password: string) => Promise<void>;
}) {
  const [useFormState, setFormState] = React.useState<{
    username: string;
    password: string;
    errorMessage: string;
  }>({
    username: "",
    password: "",
    errorMessage: "",
  });

  const handleLogin = async (event: React.FormEvent) => {
    event.preventDefault();
    try {
      setFormState({ ...useFormState, errorMessage: "" });
      await login(useFormState.username, useFormState.password);
    } catch (error) {
      setFormState({
        ...useFormState,
        errorMessage: "An error occurred, please try again.",
      });
      console.error(error);
    }
  };
  return (
    <FormContainer>
      <Form onSubmit={handleLogin}>
        <DescriptionContainer>
          <FormTitle variant="h5" color={"neutral20.main"}>
            Sign in
          </FormTitle>
          <FormText variant="h2Medium" color={"neutral20.main"}>
            Sign in to your account
          </FormText>
        </DescriptionContainer>
        <FormControl fullWidth error={!!useFormState.errorMessage}>
          <FormInputLabel htmlFor="username" style={{ fontSize: 16 }}>
            Username
          </FormInputLabel>
          <FromInput
            id="username"
            type="text"
            label="Username"
            name="username"
            value={useFormState.username}
            inputProps={{ autoCapitalize: "none" }}
            onChange={(e) =>
              setFormState({ ...useFormState, username: e.target.value })
            }
          />
        </FormControl>
        <FormControl fullWidth error={!!useFormState.errorMessage}>
          <FormInputLabel htmlFor="password">Password</FormInputLabel>
          <FromInput
            id="password"
            type="password"
            label="Password"
            name="password"
            value={useFormState.password}
            onChange={(e) =>
              setFormState({ ...useFormState, password: e.target.value })
            }
          />
          {!!useFormState.errorMessage && (
            <FormErrorText>{useFormState.errorMessage}</FormErrorText>
          )}
        </FormControl>
        <SubmitButton
          type="submit"
          variant="contained"
          color="continue"
          disabled={!(useFormState.username && useFormState.password)}
        >
          Continue
        </SubmitButton>
        <PrivacyText variant="body2">
          Your privacy is important to us. Read more in our{" "}
          <Link href="https://www.bighealth.com/privacy" target="_blank" color={"neutral10.main"}>
            Privacy Policy
          </Link>
          .
        </PrivacyText>
      </Form>
    </FormContainer>
  );
}
